import React from 'react';
import { RenewDepositForm, UpdateConfirmationModal } from 'components';
import { useUpdateDeposit } from 'providers';
import { usePageTracking } from 'hooks';
import { TRACKING_PAGES } from 'api';

export const RenewDepositPage: React.FC = () => {
  const { updated } = useUpdateDeposit();

  usePageTracking(TRACKING_PAGES.RENOUVELLEMENT);

  return (
    <>
      <RenewDepositForm />
      <UpdateConfirmationModal isOpen={updated} />
    </>
  );
};
